import { Icon } from 'Icon'

export default function Podcasts() {
    return (
        <>
            <div className="h-full flex items-center justify-center flex-col">
                <Icon src="signal" size={64} className="mb-5" />
                <h3 className="text-3xl font-semibold mb-2">Follow your first podcast</h3>
                <p className="mb-8">Follow podcasts you like by tapping the follow button.</p>
                <button className="bg-white rounded-full h-10 px-9 tracking-widest transition-all transform hover:scale-105 uppercase text-black text-xs font-bold">
                    Find podcasts
                </button>
            </div>
        </>
    )
}
